import React, { useState } from "react";
import { Auth } from "aws-amplify";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const ResetPassword = () => {
  const navigate = useNavigate();
  const [data, setData] = useState("reset");
  const [confirmationCode, setConfirmationCode] = useState({
    username: "",
    authenticationCode: "",
    new_password: "",
  });
  const [validUsername, setvalidUsername] = useState("");
  const [validAuthenticationCode, setvalidAuthenticationCode] = useState("");
  const [validPassword, setvalidPassword] = useState("");

  const handleChange = (e) => {
    setConfirmationCode({
      ...confirmationCode,
      [e.target.name]: e.target.value,
    });
  };

  const confirmationCodeSend = async () => {
    const { username } = confirmationCode;
    try {
      if (username === "") {
        setvalidUsername("Email is required");
      } else {
        await Auth.forgotPassword(username);
        setData("otp");
        toast.success("OTP send successfully", { autoClose: 5000 });
      }
    } catch (error) {
      toast.error(error.message, { autoClose: 5000 });
    }
  };

  const verifySignUp = async () => {
    const { username, authenticationCode, new_password } = confirmationCode;
    try {
      if (authenticationCode === "") {
        setvalidAuthenticationCode("Authentication Code is required");
      }
      if (new_password === "") {
        setvalidPassword("New Password is required");
      } else {
        await Auth.forgotPasswordSubmit(
          username,
          authenticationCode,
          new_password
        );
        setData("newPass");
        navigate("/signIn");
        toast.success("Password is updated successfully", { autoClose: 5000 });
      }
    } catch (error) {
      toast.error(error.message, { autoClose: 5000 });
    }
  };

  const isValidEmail = (email) => {
    return /\S+@\S+\.\S+/.test(email);
  };

  return (
    <div className="h-screen w-full flex justify-center items-center p-[20px]">
      <div className="max-w-[500px] rounded-lg w-full shadow-lg bg-white sm:p-[50px] p-[20px]">
        {data === "reset" && (
          <div>
            <h3 className="text-gray-700 font-semibold sm:text-[20px] text-[18px]">
              Reset your password
            </h3>
            <div className="mt-5">
              <div>
                <p className="font-medium text-sm text-gray-700">
                  Enter the email address associated with your account and we'll
                  send you a link to reset your password.
                </p>
              </div>
              <div className="flex flex-col gap-2 mt-7">
                <label className="font-medium text-sm text-gray-700">
                  Email
                </label>
                <input
                  type="email"
                  name="username"
                  onChange={(e) => handleChange(e)}
                  className="border-[1px] border-gray-300 focus:outline-none text-gray-600 px-[10px] py-[7px] rounded-md"
                />
                <p className="text-red-600">
                  {confirmationCode.username === "" ? validUsername : ""}
                  {confirmationCode.username !== "" &&
                    !isValidEmail(confirmationCode.username)
                    ? "Email is incorrect"
                    : ""}
                </p>
              </div>
            </div>
            <div className="mt-5">
              <button
                onClick={() => confirmationCodeSend()}
                className="text-center px-3 sm:py-3 py-2 rounded-md bg-[#5851ff] w-full text-sm font-medium text-white"
              >
                Continue
              </button>
            </div>
            <button
              className="sm:mt-7 mt-5 text-[#5851ff] text-sm font-medium flex mx-auto"
              onClick={() => navigate("/signIn")}
            >
              Return to sign in
            </button>
          </div>
        )}
        {data === "otp" && (
          <div>
            <h3 className="text-gray-700 font-semibold sm:text-[20px] text-[18px]">
              Confirm your OTP
            </h3>
            <div className="mt-5">
              <div>
                <p className="font-medium text-sm text-gray-700">
                  Enter your OTP in given field.
                </p>
              </div>
              <div className="flex flex-col gap-2 mt-7">
                <label className="font-medium text-sm text-gray-700">
                  Enter OTP
                </label>
                <input
                  name="authenticationCode"
                  onChange={(e) => handleChange(e)}
                  type="password"
                  className="border-[1px] border-gray-300 focus:outline-none text-gray-600 px-[10px] py-[7px] rounded-md"
                />
                <p className="text-red-600">
                  {confirmationCode.authenticationCode === ""
                    ? validAuthenticationCode
                    : ""}
                </p>
              </div>
              <div className="flex flex-col gap-2 mt-7">
                <label className="font-medium text-sm text-gray-700">
                  New Password
                </label>
                <input
                  name="new_password"
                  onChange={(e) => handleChange(e)}
                  type="password"
                  className="border-[1px] border-gray-300 focus:outline-none text-gray-600 px-[10px] py-[7px] rounded-md"
                />
                <p className="text-red-600">
                  {confirmationCode.new_password === "" ? validPassword : ""}
                </p>
              </div>
            </div>
            <div className="mt-5">
              <button
                onClick={() => verifySignUp()}
                className="text-center px-3 sm:py-3 py-2 rounded-md bg-[#5851ff] w-full text-sm font-medium text-white"
              >
                Confirm OTP
              </button>
            </div>
          </div>
        )}
        {data === "newPass" && (
          <div>
            <h3 className="text-gray-700 font-semibold sm:text-[20px] text-[18px]">
              Set New Password
            </h3>
            <div className="flex flex-col gap-2 mt-7">
              <label className="font-medium text-sm text-gray-700">
                New Password
              </label>
              <input
                type="password"
                className="border-[1px] border-gray-300 focus:outline-none text-gray-600 px-[10px] py-[7px] rounded-md"
              />
            </div>
            <div className="flex flex-col gap-2 mt-7">
              <label className="font-medium text-sm text-gray-700">
                Confirm Password
              </label>
              <input
                type="password"
                className="border-[1px] border-gray-300 focus:outline-none text-gray-600 px-[10px] py-[7px] rounded-md"
              />
            </div>
            <div className="mt-5">
              <button
                className="text-center px-3 sm:py-3 py-2 rounded-md bg-[#5851ff] w-full text-sm font-medium text-white"
                onClick={() => setData("newPass")}
              >
                Confirm
              </button>
            </div>
            <button
              className="sm:mt-7 mt-5 text-[#5851ff] text-sm font-medium flex mx-auto"
              onClick={() => navigate("/signIn")}
            >
              Return to sign in
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ResetPassword;
